/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentSettingListEntry
 */
export interface IncidentSettingListEntry {
    /**
     * 
     * @type {string}
     * @memberof IncidentSettingListEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentSettingListEntry
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IncidentSettingListEntry
     */
    priority: number;
}

/**
 * Check if a given object implements the IncidentSettingListEntry interface.
 */
export function instanceOfIncidentSettingListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "priority" in value;

    return isInstance;
}

export function IncidentSettingListEntryFromJSON(json: any): IncidentSettingListEntry {
    return IncidentSettingListEntryFromJSONTyped(json, false);
}

export function IncidentSettingListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentSettingListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'priority': json['priority'],
    };
}

export function IncidentSettingListEntryToJSON(value?: IncidentSettingListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'priority': value.priority,
    };
}

